import { useEffect, useState } from "react";
import { storage } from "../../firebase";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  deleteObject,
} from "firebase/storage";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Stack, TextField, Avatar, Alert, Fab, Button } from "@mui/material";
import { useUpdateUserProfileMutation, useGetUserQuery } from "./userApiSlice";

const avatarStyle = {
  height: "50%",
  width: "100%",
};

function ManageProfile() {
  const { data: user, isSuccess } = useGetUserQuery("User");
  const [image, setImage] = useState({
    data: "",
    contentType: "",
  });
  const [username, setUsername] = useState("");
  const [
    updateUserProfile,
    {
      isSuccess: isUpdateProfileSuccess,
      isError: isUpdateProfileError,
      error: errorUpdateProfile,
      reset: resetUpdateProfile,
    },
  ] = useUpdateUserProfileMutation("User");
  async function handleUploadImage(e) {
    const file = e.target.files[0];
    const imageRef = ref(storage, `images/avatars/${user._id}/${file.name}`);
    await uploadBytes(imageRef, file);
    const url = await getDownloadURL(imageRef);

    setImage({
      data: url,
      contentType: file.type,
      name: file.name,
    });
  }
  function handleOnChangeUsername(event) {
    setUsername(event.target.value);
  }
  async function updateProfile(e) {
    e.preventDefault();
    await updateUserProfile({ username: username, image: image });
    if (user.avatar.data && image.data) {
      const delImgRef = ref(
        storage,
        `images/avatars/${user._id}/${user.avatar.name}`
      );
      await deleteObject(delImgRef);
    }
  }
  useEffect(() => {
    if (isSuccess) {
      setImage({
        data: user.avatar.data,
        contentType: user.avatar.contentType,
        name: user.avatar.name,
      });
      setUsername(user.username);
    }
  }, [user, isSuccess]);

  return (
    <div>
      <header className="account-header">
        <h1>Profile</h1>
        <p>Edit your profile here.</p>
      </header>
      {isUpdateProfileSuccess && (
        <Alert
          variant="filled"
          severity="success"
          sx={{
            p: "35px",
            width: "100%",
          }}
          onClose={resetUpdateProfile}
        >
          Profile has changed successfully.
        </Alert>
      )}
      {isUpdateProfileError && (
        <Alert
          variant="filled"
          severity="error"
          sx={{
            p: "35px",
            width: "100%",
          }}
          onClose={resetUpdateProfile}
        >
          {errorUpdateProfile?.data?.message}
        </Alert>
      )}
      <form className="profile" onSubmit={updateProfile}>
        <label style={{ fontSize: "1.5rem" }} htmlFor="user-avatar">
          Image Preview
        </label>
        <div className="profile-avatar">
          {image && (
            <Avatar
              alt="user-avatar"
              src={image.data}
              variant="square"
              sx={avatarStyle}
            />
          )}
          <input
            accept="image/*"
            type="file"
            hidden
            id="upload"
            onChange={handleUploadImage}
          />
          <label htmlFor="upload">
            <Fab className="avatar-btn" component="span">
              <FileUploadIcon />
            </Fab>
          </label>
        </div>
        <Stack spacing={2} sx={{ marginTop: "80px" }}>
          <TextField
            label="Username"
            name="username"
            value={username}
            fullWidth
            focused
            onChange={handleOnChangeUsername}
          />
        </Stack>
        <Button
          className="update-profile-btn"
          variant="outlined"
          type="submit"
          size="large"
        >
          Save
        </Button>
      </form>
    </div>
  );
}
//
export default ManageProfile;
//variant="square"
//`data:${image.contentType};base64, ${image.data}`
